import { config } from '@Constants/rx-ui/constants';
import AppStorage from '@Services/AppStorage';
import * as BrowserHelper from '@Services/BrowserHelper';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import Auth from '@Services/Auth';
import { getCombinedRouteParams } from '@AppRoutes/AppRoutesSelectors';
import store from '@Store';

const isIE = BrowserHelper.detectOldIE(); // RXFE-7312: default RPP for IE11 is 15
const IE_DEFAULT = 15;

// RX-24506/FR-9.1: effective minimum results-per-page, regardless of which link in the
// precedence chain resolved the value (stale AppStorage override, route param, or saved
// user setting). Values below this floor are clamped up; values at or above pass through.
const MINIMUM_RESULTS_PER_PAGE = 20;

export const getResultsPerPage = () => {
  const { hitsPerPage } = getCombinedRouteParams(store.getState());
  const isResultsPerPageLimited = getValueByNs(Auth.getUser(), 'devOptions.resultsPerPageIELimit', true);

  const resolvedResultsPerPage =
    AppStorage.instance.get('resultsPerPage') ||
    hitsPerPage ||
    (isResultsPerPageLimited && isIE ? IE_DEFAULT : getValueByNs(Auth.getUser(), 'details.settings.pageSize', config.NUMBER_OF_PAGE_ITEMS));

  return Math.max(resolvedResultsPerPage, MINIMUM_RESULTS_PER_PAGE);
};

export const setResultsPerPage = (value) => {
  AppStorage.instance.set('resultsPerPage', value);
};
